export default __webpack_public_path__ + "static/media/User.005ee4c7.svg";